import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20soft%20pastel%20shapes%20in%20warm%20sand%20beige%20and%20olive%20green%20tones%20on%20cream%20background%2C%20subtle%20gradient%20texture%2C%20minimalist%20editorial%20design%20with%20organic%20flowing%20curves%2C%20clean%20modern%20aesthetic%20with%20generous%20negative%20space%2C%20luxurious%20matte%20finish&width=1800&height=1000&seq=kakobuy-hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet tło produktowe"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 lg:w-[60%]">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6 animate-fade-in-up">
              <i className="ri-sparkling-line"></i>
              <span>Nr 1 w Polsce</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight tracking-tight animate-fade-in-up animate-delay-100">
              Kakobuy Spreadsheet
            </h1>
            <p className="font-heading text-xl md:text-2xl lg:text-3xl text-foreground-700 mt-3 leading-snug animate-fade-in-up animate-delay-200">
              Największa Baza Produktów i Finds dla Polskich Kupujących
            </p>
            <p className="text-foreground-600 text-base md:text-lg mt-5 max-w-xl leading-relaxed animate-fade-in-up animate-delay-300">
              Znajdź najlepsze produkty, aktualne linki, popularne finds oraz szczegółowe przewodniki zakupowe w jednym miejscu.
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-8 animate-fade-in-up animate-delay-400">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2"
              >
                Przeglądaj Kakobuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/artykul/kakobuy-spreadsheet-poradnik"
                className="px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-100 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-book-open-line"></i>
                Zobacz poradnik
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 animate-fade-in-up animate-delay-500">
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-check-line text-primary-500 text-sm"></i>
                <span>Aktualizowane listy</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-check-line text-primary-500 text-sm"></i>
                <span>Szczegółowe porównania</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-check-line text-primary-500 text-sm"></i>
                <span>Poradniki bezpieczeństwa</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-check-line text-primary-500 text-sm"></i>
                <span>Bezpłatny dostęp</span>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex lg:w-[35%] items-start pt-8">
            <div className="bg-background-50/80 backdrop-blur-sm rounded-2xl p-6 border border-background-200/60 w-full">
              <div className="rounded-xl overflow-hidden mb-4">
                <img
                  src="https://readdy.ai/api/search-image?query=Organic%20arrangement%20of%20minimalist%20fashion%20accessories%20and%20fabric%20swatches%20on%20textured%20linen%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20style%20with%20earthy%20terracotta%20and%20warm%20olive%20accents%2C%20natural%20cotton%20and%20wool%20textures%2C%20thoughtful%20elevated%20composition&width=800&height=500&seq=hero-side-card-v2&orientation=landscape"
                  alt="Kakobuy produkty"
                  className="w-full h-48 object-cover object-top rounded-xl"
                />
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">Trendy tygodnia</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">
                Najnowsze znaleziska i popularne produkty zaktualizowane w tym tygodniu. Sprawdź, co jest teraz na topie.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1 mt-3 text-primary-600 text-xs font-medium hover:text-primary-700 transition-colors"
              >
                Zobacz więcej <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}